import type { SignatureSource } from '@ups/xplat/utils';

export interface TrainingEnrollment {
  trainingEnrollmentId: string;
  trainingId: string;
  absorbCourseId: string;
  trainingDate: string;
  facilityId: number;
  instructorHRRef: number;
  hRRef: number;
  absorbUserId: string;
  signatureFileId: string;
  signedOn: string | null;
  /** DRAWN | REUSED audit flag recorded on the enrollment record (WI 31501). */
  signatureSource?: SignatureSource | null;
}
